import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from 'src/app/shared/configurations/configurations.factory';
import { Configurations } from 'src/app/shared/configurations/models/configurations.model';
import { ApiEnumerationModel } from '../DTOs/base-DTOs/api-enumeration-model.dto';
import { FacebookConfigurationDto } from '../DTOs/facebook-form-configuration.dto';
import { FacebookFormConfigurationUpdateDto } from '../DTOs/facebook-form-configuration-update.dto';
import { ApiStatus } from '../DTOs/base-DTOs/api-status.dto';
import { FacebookFormConfigurationCreateDto } from '../DTOs/facebook-form-configuration-create.dto';
import { ApiObjectModel } from '../DTOs/base-DTOs/api-object-model.dto';
import { ApiModel } from '../DTOs/base-DTOs/api-model.dto';
import { WebhooksBatchDto } from '../DTOs/faceboo-batch.dto';

@Injectable({
  providedIn: 'root'
})
export class FacebookProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: HttpClient) {
    this.baseUrl = config.environmentConfig.lobbyBaseUrl + '/facebook'
  }

  searchFacebookForms$(
    pageIndex: number | null = null,
    pageSize: number | null = null,

    isEnabled: boolean | null = null,
    leadInjectorId: number | null = null,
    formId: string | null = null,
    formName: string | null = null
  ): Observable<ApiEnumerationModel<FacebookConfigurationDto>> {

    let query: string = '';

    if (pageIndex) query = query + `${query ? '&' : ''}pg_ix=${pageIndex}`
    if (pageSize) query = query + `${query ? '&' : ''}pg_sz=${pageSize}`

    if (isEnabled !== null) query = query + `${query ? '&' : ''}isEnabled=${isEnabled}`
    if (leadInjectorId) query = query + `${query ? '&' : ''}LeadInjectorId=${leadInjectorId}`
    if (formId) query = query + `${query ? '&' : ''}formId=${formId}`
    if (formName) query = query + `${query ? '&' : ''}formName=${formName}`

    return this.httpClient.get<ApiEnumerationModel<FacebookConfigurationDto>>(this.baseUrl + `/configuration/form${query ? '?' : ''}${query}`)
  }

  getFacebookForm$(id: number
  ): Observable<ApiObjectModel<FacebookConfigurationDto>> {
    return this.httpClient.get<ApiObjectModel<FacebookConfigurationDto>>(this.baseUrl + `/configuration/form/${id}`)
  }

  createFacebookForm$(dto: FacebookFormConfigurationCreateDto): Observable<ApiObjectModel<FacebookConfigurationDto>> {
    return this.httpClient.post<ApiObjectModel<FacebookConfigurationDto>>(this.baseUrl + '/configuration/form', dto)
  }

  updateFacebookForm$(id: number, dto: FacebookFormConfigurationUpdateDto) {
    return this.httpClient.put<ApiModel>(this.baseUrl + `/configuration/form/${id}`, dto)
  }

  deleteFacebookForm$(id: number) {
    return this.httpClient.delete<ApiModel>(this.baseUrl + `/configuration/form/${id}`)
  }

  searchLogs$(pageIndex: number | null = null,
    pageSize: number | null = null,
    formId: number | null = null) {

    let query: string = '';

    if (pageIndex) query = query + `${query ? '&' : ''}pg_ix=${pageIndex}`
    if (pageSize) query = query + `${query ? '&' : ''}pg_sz=${pageSize}`

    if (formId !== null) query = query + `${query ? '&' : ''}FormConfigurationId=${formId}`

    return this.httpClient.get<ApiEnumerationModel<WebhooksBatchDto>>(this.baseUrl + `/log` + `${query ? '?' : ''}${query}`)
  }
}
